<template>
    <v-card>
      <v-card-text class="headline text-xs-center secondary--text">
        Cadastro SmartLock
      </v-card-text>
      <v-container grid-list-lg class="pt-0">
          <v-layout row wrap>
              <v-flex xs12>
                  <label for="codigo">Codigo</label>
                  <v-text-field
                  v-model="codigo"
                  label="Digite o seu codigo"
                  outline
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword = !showPassword"
                  required
                  :min="4"
                />
              </v-flex>
              <v-flex xs12>
                  <label>Confirme seu codigo</label>
                  <v-text-field
                  v-model="codigo_confirmacao"
                  label="Confirme o seu codigo"
                  :type="'password'"
                  outline
                  required
                  :min="4"
                />
              </v-flex>
          </v-layout>
      </v-container>
        <v-card-actions>
            <v-btn flat color="grey darken-2" @click="fechar">
                CANCELAR
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="cadastrar" flat color="green" :loading="loading">
                CONFIRMAR
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      opcao: 'cadastrar',
      codigoatual: null,
      codigo: null,
      codigo_confirmacao: null,
      step: 1,
      btn1: '',
      btn2: '',
      showPassword: false
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    smartLock () {
      return this.$store.getters.smartLock
    }
  },
  methods: {
    fechar () {
      this.btn1 = ''
      this.btn2 = ''
      this.codigoatual = null
      this.codigo = null
      this.codigo_confirmacao = null
      this.$emit('fechar')
    },
    testarCodigo () {
      if (this.codigo !== this.codigo_confirmacao) {
        alert('O Codigo não corresponde')
        return false
      }
      if (this.codigo.length < 4) {
        alert('O seu código precisa ter no mínimo 4 dígitos')
        return false
      }
      return true
    },
    cadastrar () {
      if (this.testarCodigo() === true) {
        this.$store.dispatch('cadastrarpin', this.codigo).then((response) => {
          if (response === 'ok') {
            this.fechar()
            alert('Cadastrado')
          } else {
             alert('Não foi possível realizar cadastro do seu smartlock')
          }
        }).catch(error => {
          alert(error)
        })
      }
    }
  }
}
</script>
